var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "nav_three_level_viewcolumn",
      class: [
        this.$store.state.menubarRouters.full ||
        _vm.hide ||
        this.$route.query.hide
          ? "full"
          : "",
        this.$store.state.user.authencaticationStatus.packageArray.length > 0
          ? "has-notify"
          : "",
      ],
    },
    [
      _c("crumbs", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.hide,
            expression: "!hide",
          },
        ],
      }),
      this.$store.state.user.authencaticationStatus.packageArray.length > 0
        ? _c("notify")
        : _vm._e(),
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _c(
          "div",
          {
            ref: "pgWrap",
            staticClass: "pageWrap",
            style: "" + (_vm.hide ? "height: 100%" : ""),
          },
          [
            _c(
              "el-scrollbar",
              {
                ref: "scrollbar",
                staticClass: "content-scrollbar",
                staticStyle: { height: "100%" },
              },
              [
                _c(
                  "keep-alive",
                  { attrs: { include: _vm.cachePageName } },
                  [
                    _vm.$route.meta.keepAlive
                      ? _c("router-view", { staticClass: "page-content" })
                      : _vm._e(),
                  ],
                  1
                ),
                !_vm.$route.meta.keepAlive
                  ? _c("router-view", { staticClass: "page-content" })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }